import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseURL } from "./Config/globals";
import { Subject, of } from 'rxjs';
import { tap, catchError, finalize } from 'rxjs/operators';
import memberSession from './Config/member-session';
import { NgxSpinnerService } from 'ngx-spinner';
import { LoadingService } from './Services/loading.service';

@Injectable()
export class CustomAjax {
  memberSession = memberSession;
  internalHTTP: HttpClient;

  constructor(private http: HttpClient, private spinner: NgxSpinnerService, public loadingService: LoadingService) {
    this.internalHTTP = http;
  }

  public ShowSpinner(name: string = 'MainApp') {
    this.memberSession.TransactionCount++;
    this.spinner.show(name);
    this.loadingService.show();
  }

  public HideSpinner(name: string = 'MainApp') {
    this.memberSession.TransactionCount--;
    if (this.memberSession.TransactionCount <= 1) {
      this.spinner.hide(name);
      this.loadingService.hide();
      this.memberSession.TransactionCount = 0;
    }
  }

  private MemberSessionChanged = new Subject<any>();
  MemberSessionChanged$ = this.MemberSessionChanged.asObservable();

  MemberSessionOnChanged(value: any) {
    this.MemberSessionChanged.next(value);
  }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  public GetData(url: string, Parameters: string, fn: (object: any) => void, fnError: (object: any) => void, options?: any) {
    if (url.indexOf('?') === -1) url = url + '?';
    if (options !== 'IGNORE SPINNER') this.ShowSpinner();

    return this.internalHTTP.get(BaseURL + url + Parameters).pipe(
      tap((data: any) => {
        if (data != null && (data as BaseReturn).Success === false && (data as BaseReturn).UserErrorMessage === "#MemberSession") {
          this.MemberSessionOnChanged("#MemberSession");
        }
        if (fn) fn(data);
      }),
      catchError((error: any) => {
        if (error.error != null && (error.error as BaseReturn).Success === false && (error.error as BaseReturn).UserErrorMessage === "#MemberSession") {
          this.MemberSessionOnChanged("#MemberSession");
        }
        if (fnError) fnError(error);
        console.log("CustomAjax - subscribe error", error);
        return of(error);
      }),
      finalize(() => {
        if (options !== 'IGNORE SPINNER') this.HideSpinner();
      })
    ).subscribe();
  }

  public GetJSONData(url: string, Parameters: string, fn: (object: any) => void, fnError: (object: any) => void, options?: any) {
    if (url.indexOf('?') === -1) url = url + '?';
    if (options !== 'IGNORE SPINNER') this.ShowSpinner();

    return this.internalHTTP.get(BaseURL + url + Parameters).pipe(
      tap((data: any) => {
        if (data != null && (data as BaseReturn).Success === false && (data as BaseReturn).UserErrorMessage === "#MemberSession") {
          this.MemberSessionOnChanged("#MemberSession");
        }
        if (fn) {
          (data as BaseReturn).Data = JSON.parse((data as BaseReturn).Data);
          fn(data);
        }
      }),
      catchError((error: any) => {
        if (error.error != null && (error.error as BaseReturn).Success === false && (error.error as BaseReturn).UserErrorMessage === "#MemberSession") {
          this.MemberSessionOnChanged("#MemberSession");
        }
        if (fnError) fnError(error);
        console.log("CustomAjax - subscribe error", error);
        return of(error);
      }),
      finalize(() => {
        if (options !== 'IGNORE SPINNER') this.HideSpinner();
      })
    ).subscribe();
  }

  public PostData(url: string, parameter: any, fn: (object: any) => void, fnError: (object: any) => void, options?: string) {
    if (options !== 'IGNORE SPINNER') this.ShowSpinner();

    let o;
    if (url.indexOf('http') === -1) {
      o = parameter;
      url = BaseURL + url;
    } else {
      o = { inputJSON: JSON.stringify(parameter) };
    }

    return this.internalHTTP.post(url, o, this.httpOptions).subscribe({
      next: (data: any) => {
        if (data != null && (data as BaseReturn).Success === false && (data as BaseReturn).UserErrorMessage === "#MemberSession") {
          this.MemberSessionOnChanged("#MemberSession");
          if (options !== 'IGNORE SPINNER') this.HideSpinner();
          return;
        }
        if (fn) fn(data);
        if (options !== 'IGNORE SPINNER') this.HideSpinner();
      },
      error: (error: any) => {
        if (error.error != null && (error.error as BaseReturn).Success === false && (error.error as BaseReturn).UserErrorMessage === "#MemberSession") {
          this.MemberSessionOnChanged("#MemberSession");
          if (options !== 'IGNORE SPINNER') this.HideSpinner();
          return;
        }
        if (options !== 'IGNORE SPINNER') this.HideSpinner();
        if (fnError) fnError(error);
      },
      complete: () => { }
    });
  }

  public PostJSONData(url: string, parameter: any, fn: (object: any) => void, fnError: (object: any) => void, options?: any) {
    if (options !== 'IGNORE SPINNER') this.ShowSpinner();

    let o;
    if (url.indexOf('http') === -1) {
      o = parameter;
      url = BaseURL + url;
    } else {
      o = { inputJSON: JSON.stringify(parameter) };
    }

    return this.internalHTTP.post(url, o, this.httpOptions).pipe(
      tap((data: any) => {
        if (data != null && (data as BaseReturn).Success === false && (data as BaseReturn).UserErrorMessage === "#MemberSession") {
          this.MemberSessionOnChanged("#MemberSession");
        }
        if (fn) {
          (data as BaseReturn).Data = JSON.parse((data as BaseReturn).Data);
          fn(data);
        }
      }),
      catchError((error: any) => {
        if (error.error != null && (error.error as BaseReturn).Success === false && (error.error as BaseReturn).UserErrorMessage === "#MemberSession") {
          this.MemberSessionOnChanged("#MemberSession");
        }
        if (fnError) fnError(error);
        console.log("CustomAjax - subscribe error", error);
        return of(error);
      }),
      finalize(() => {
        if (options !== 'IGNORE SPINNER') this.HideSpinner();
      })
    ).subscribe();
  }
}

export class BaseReturn {
  Success?: boolean;
  Data: any;
  UserErrorMessage?: string;
  ID?: number;
  InformationMessage?: string;
}
